export default __webpack_public_path__ + "static/media/strategy4.9e8758d4.png";